module.exports = __webpack_public_path__ + "img/spade.b8b1e996.png";